import React, { Component } from "react";
// import { Form,  message, Button, Icon } from 'antd';
import { Upload, message, Button, Icon } from "antd";
import { UploadFile, ShowUploadListInterface, RcCustomRequestOptions } from "antd/lib/upload/interface";
import UploadService from "../upload.service";
import "../style.css";
const { Dragger } = Upload;
export interface iProps {
  uploadSignURL?: string;
  maxFileNumber?: number;
  maxFileLength?: number;
  minFileLength?: number;
  label?: string;
  fileType?: string;
  filePatten?: string;
  fileList?: any[];
  action?: string;
  multiple?: boolean;
  directory?: boolean;
  disabled?: boolean;
  showUploadList?: boolean | ShowUploadListInterface;
  onChange?: (files: any[]) => void;
  children?: React.ReactNode;
}
export default class PdfUpload extends Component<iProps> {
  private uploadService: UploadService = new UploadService();
  state: any = {
    OSSData: {},
    fileList: [],
  };
  initFileList = (fileList = []) => {
    return fileList.map((file) => ({
      ...file,
      newUploadFlag:
        typeof file.newUploadFlag === "undefined" ? false : file.newUploadFlag,
      url: file.fileUrl,
    }));
  };
  componentDidMount() {
    const { fileList = [] } = this.props;
    this.setState({
      fileList: this.initFileList(fileList),
    });
  }
  componentWillReceiveProps(newProps) {
    const { fileList = [] } = newProps;
    this.setState({
      fileList: this.initFileList(fileList),
    });
  }
  transformFile = (file) => {
    const { OSSData } = this.state;
    const urlObj=new URL(OSSData.putSignUrl)
    file.url = `${urlObj.origin}${urlObj.pathname}`;
    file.fileUrl = `${urlObj.origin}${urlObj.pathname}`;
    file.uid = OSSData.fileId;
    file.newUploadFlag = true;
    return file;
  };
  getExtraData = (file) => {
    const { OSSData } = this.state;
    return {
      key: `${OSSData.dir}/${OSSData.fileId}`,
      dir: OSSData.dir,
      OSSAccessKeyId: OSSData.accessid,
      policy: OSSData.policy,
      Signature: OSSData.signature,
    };
  };
  onChange = ({ fileList, file, event }) => {
    const { onChange } = this.props;
    if (onChange) {
      onChange([...fileList]);
    }
  };

  beforeUpload = (file): any => {
    let {
      maxFileLength = 4096,
      minFileLength = 0,
      filePatten = "(.doc|.docx|.pdf)$",
    } = this.props;
    if (filePatten && !new RegExp(filePatten).test(file.name)) {
      message.warn(`文件类型无效！`);
      return false;
    }
    const suffix = file.name.slice(file.name.lastIndexOf("."));
    const isLtMaxFileLength = file.size / 1024 / 1024 < maxFileLength;
    if (!isLtMaxFileLength) {
      message.warn(`单个文件体积不能大于${maxFileLength}MB`);
      return isLtMaxFileLength;
    }
    const isGtMaxFileLength = file.size / 1024 / 1024 > minFileLength;
    if (!isGtMaxFileLength) {
      message.warn(`单个文件体积不能小于${minFileLength}MB`);
      return isGtMaxFileLength;
    }

    return new Promise<void>(async (resolve, reject) => {
      try {
        let data = await this.uploadService.getOssData(
          this.props.uploadSignURL
        );
    
        await this.setState({
          OSSData: data,
        });
        resolve();
      } catch (error) {
        reject();
      }
    });
  };
  customRequest=(options: RcCustomRequestOptions)=>{
    const {file,onProgress,onSuccess}=options
    const xhr = new XMLHttpRequest()
    xhr.upload.addEventListener('progress', (event) => {
        if (event.lengthComputable) {
            onProgress({ percent:event.loaded/event.total*100 },file)
        }
    })
    xhr.addEventListener('load', (event) => {
        // 文件上传完成
        console.log('文件上传完成', event)
        if (xhr.status === 200) {
          onSuccess(xhr.response,file )    
        }
    })
    xhr.addEventListener('error', (event) => {
        // 文件上传发生错误
        console.error('文件上传发生错误',event)
    })
    xhr.open('PUT', this.state.OSSData.putSignUrl)
    xhr.setRequestHeader('Content-Type', file.type);
    xhr.send(file)
  }
  render() {
    const {
      fileList = [],
      multiple = false,
      directory = false,
      showUploadList,
      maxFileNumber = 100,
      label = "",
      children = "",
      filePatten = "",
    } = this.props;

    return (
      <Dragger
        disabled={fileList.length >= maxFileNumber}
        accept={filePatten}
        name="file"
        multiple={multiple}
        directory={directory}
        fileList={fileList}
        showUploadList={showUploadList}
        action={this.state.OSSData.host}
        onChange={this.onChange}
        transformFile={this.transformFile}
        // data={this.getExtraData}
        customRequest={this.customRequest}
        beforeUpload={this.beforeUpload}
      >
        <div className="pdf-upload">
          {" "}
          {label && <span>{label}</span>}{" "}
          <p className="ant-upload-drag-icon">
            <Icon type="container" />
          </p>
          {fileList.length >= maxFileNumber ? (
            <>
              <p className="upload-text">{`已选择文件`}<span className="upload-hint-type">{`${fileList?.[0].name}`}</span></p>
              <p className="upload-hint">请点击下方确定按钮，完成上传</p>
            </>
          ) : (
            <>
              <p className="upload-text">点击文件或将文件拖拽到此处</p>
              <p className="upload-hint">
                请上传<span className="upload-hint-type">pdf、word</span>格式的文件
              </p>
            </>
          )}
        </div>
      </Dragger>
    );
  }
}
